import logoMarkTrim from '@ds/assets/logo-mark-trim.png';
import logoMarkWhite from '@ds/assets/logo-mark-white.png';

export const LOGO_MARK = logoMarkTrim;
export const LOGO_MARK_WHITE = logoMarkWhite;
